import React, { type JSX } from 'react';
import { Box, Theme } from "@mui/material";
import { SxProps } from '@mui/system';


export type TabContainerProps = {
    visible: boolean;
    sx?: SxProps<Theme>;
    children: JSX.Element
};

export default function TabContainer({visible, 
    children,
    sx} : TabContainerProps) {

    return (
        
        <Box
            sx={{
                position: 'relative',
                display: visible ? 'flex' : 'none',
                flexDirection: "column",
                flex: '1 1 auto',
                overflow: "hidden",
                height: "100%",
                ...sx}}>
            {/* {children} */}
            {/* children are immutable so clone to add visible prop */}
            {React.Children.map(children, (child) => React.cloneElement(child, { ...child.props, visible: visible }))}
        </Box>
    );
  }
